import React, { useState } from 'react';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';

const Faq = ({ id }) => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);
  const faqData = Array.from({ length: 10 }, (_, index) => ({
    question: t(`faq_question_${index + 1}`),
    answer: t(`faq_answer_${index + 1}`),
  }));

  const toggleAccordion = (index) => {
    setOpenIndex((current) => current === index ? null : index);
  };

  return (
    <Element name={id}>
      <section className="faqSection" aria-labelledby="faq-title">
        <div className="faqCard">
          <header className="faqHeader">
            <p className="faqEyebrow">FAQ</p>
            <span>{t('faq_topicCount')}</span>
          </header>

          <div className="faqIntroduction">
            <h2 id="faq-title">{t('faq_title')}</h2>
            <p>{t('faq_intro')}</p>
          </div>

          <div className="faqList">
            {faqData.map((faqItem, index) => {
              const isOpen = openIndex === index;
              const answerId = `faq-answer-${index}`;

              return (
                <article key={faqItem.question} className={`faqItem${isOpen ? ' faqItemOpen' : ''}`}>
                  <button
                    className="faqQuestion"
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls={answerId}
                    onClick={() => toggleAccordion(index)}
                  >
                    <span className="faqNumber">{String(index + 1).padStart(2, '0')}</span>
                    <span>{faqItem.question}</span>
                    <span className="faqToggle" aria-hidden="true">
                      <FontAwesomeIcon icon={faChevronDown} />
                    </span>
                  </button>
                  <div id={answerId} className="faqAnswer" hidden={!isOpen}>
                    <p>{faqItem.answer}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Faq;
